import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Table, Input, Radio, message, Button, Card, Popconfirm } from 'antd';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import {
	deleteUser,
	disableUser,
	downloadUsersCSV,
	fetchFacilityActiveUsers,
	fetchFacilityInactiveUsers,
	fetchFacilityInvitedUsers,
	fetchFacilityUsers,
	reinviteUser,
} from '../../thunks/users_thunks';
import { statusIndicatorFormatter } from '../../utils/DataFormatterUtils';
import {
	compareStrings,
	getObjectValues,
	hasAccessToAllLocations,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import BuyerUserInviteForm from '../buyer_user_invite_form/BuyerUserInviteForm';
import {
	buyerSignUpInvite,
	buyerRoleUpdateUser,
	buyerUpdateUserContact,
	adminChangePassword,
} from '../../thunks/buyer_contacts_thunks';
import { ROLES } from '../roles/roles';
import SubnavBar from '../subnav_bar/SubnavBar';
import { debounce } from '../../utils/PerformanceUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import queryString from 'querystring';
import PasswordUpdateForm from '../password_update_form/PasswordUpdateForm';
import BuyerAdminRoleUpdateForm from '../buyer_role_update_form/BuyerAdminRoleUpdateForm';
import { DownloadOutlined } from '@ant-design/icons';
const { Content } = Layout;

require('./BuyerAdminUsersPage.less');

const initState = {
	filteredInfo: null,
	sortedInfo: null,
	visible: false,
	roleUpdateVisible: false,
	userContact: null,
	displayMode: 'active',
	changePasswordVisible: false,
	searchText: undefined,
	isReinvite: false,
};

interface SourcingPageState {
	filteredInfo: any;
	sortedInfo: any;
	visible: boolean;
	roleUpdateVisible: boolean;
	userContact: any;
	displayMode: any;
	changePasswordVisible: any;
	passwordFormVisible: boolean;
	searchText: any;
	isReinvite: any;
}

class BuyerAdminUsersPage extends React.Component<any, SourcingPageState> {
	formRefs: any;
	initialPagination: any = {
		current: 1,
		pageSize: 10,
		showSizeChanger: true,
		pageSizeOptions: ['5', '10', '25', '50'],
		onChange: (current, size) => this.handleSizeChange(current, size),
	};
	constructor(props) {
		super(props);
		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, ...other } = queryParams;
		this.state = {
			...initState,
		};
		this.initialPagination = { ...this.initialPagination, current: current, pageSize: pageSize };
		this.handleChange = this.handleChange.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.handleBuyerUserInviteCancel = this.handleBuyerUserInviteCancel.bind(this);
		this.handleBuyerUserInviteSubmit = this.handleBuyerUserInviteSubmit.bind(this);
		this.showInviteUserModal = this.showInviteUserModal.bind(this);
		this.handleBuyerRoleUpdateSubmit = this.handleBuyerRoleUpdateSubmit.bind(this);
		this.handleBuyerRoleUpdateCancel = this.handleBuyerRoleUpdateCancel.bind(this);
		this.handleBuyerReinviteSubmit = this.handleBuyerReinviteSubmit.bind(this);
		this.showRoleUpdateModal = this.showRoleUpdateModal.bind(this);
		this.showChangePasswordModal = this.showChangePasswordModal.bind(this);
		this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this);
		this.handleChangePasswordCancel = this.handleChangePasswordCancel.bind(this);
		this.formRefs = {
			userInviteForm: null,
			roleUpdateForm: null,
			reinviteForm: null,
			changePasswordForm: null,
		};
	}

	handleSizeChange = (current, size) => {
		const { history, location } = this.props;
		let backUrl = `/buyer/admin/users?`;
		let searchParams = new URLSearchParams(location.search);
		searchParams.set('current', current);
		searchParams.set('pageSize', size);
		history.push(backUrl.concat(searchParams.toString()));
		this.initialPagination = { ...this.initialPagination, current: current, pageSize: size };
		this.fetchUsers();
	};

	fetchUsers = () => {
		const {
			fetchBuyerActiveUsers,
			fetchBuyerUsers,
			fetchInvitedBuyerUsers,
			fetchInactiveBuyerUsers,
		} = this.props;
		const { searchText, displayMode } = this.state;
		if (displayMode === 'active') {
			fetchBuyerActiveUsers({ search: searchText });
		} else if (displayMode === 'inactive') {
			fetchInactiveBuyerUsers({ search: searchText });
		} else if (displayMode === 'invited') {
			fetchInvitedBuyerUsers({ search: searchText });
		} else {
			fetchBuyerUsers({ search: searchText });
		}
	};

	componentDidMount() {
		this.fetchUsers();
	}

	showInviteUserModal(e) {
		this.setState({
			userContact: undefined,
			visible: true,
		});
	}

	showRoleUpdateModal = (record) => (e) => {
		this.setState({
			roleUpdateVisible: true,
			userContact: record,
		});
	};

	showChangePasswordModal = (record) => (e) => {
		this.setState({
			changePasswordVisible: true,
			userContact: record,
		});
	};

	handleChange(pagination, filters, sorter) {
		this.setState({
			filteredInfo: filters,
			sortedInfo: sorter,
		});
	}

	clearFilters() {
		this.setState({ filteredInfo: null });
	}

	clearAll() {
		this.setState({
			filteredInfo: null,
			sortedInfo: null,
		});
	}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleBuyerUserInviteSubmit(values) {
		const { inviteNewUser } = this.props;
		const contact = {
			...values,
			nameFamily: values.nameFamily || '',
			roles: [values.roles],
			hasAccessToAllLocations: hasAccessToAllLocations(values.roles, values) || false,
		};
		if (!contact.hasAccessToAllLocations) {
			contact['locationIds'] = values.locationIds;
		}

		inviteNewUser(contact).then(() => {
			this.setState({ visible: false });
			this.fetchUsers();
			message.success(`Invite sent to ${contact.nameGiven} at ${contact.email}.`);
		});
	}

	handleBuyerUserInviteCancel(e) {
		this.setState({
			visible: false,
			isReinvite: false,
		});
	}

	handleBuyerRoleUpdateSubmit(values) {
		const { updateUserContact } = this.props;

		const updateContact = {
			...values,
			userId: values.email,
			roles: [values.roles],
		};
		if (!values.hasAccessToAllLocations) {
			updateContact['locationIds'] = values.locationIds;
		}

		updateUserContact(updateContact).then(() => {
			this.setState({ roleUpdateVisible: false });
			this.fetchUsers();
			message.success(`Role Updated`);
		});
	}

	handleBuyerRoleUpdateCancel(e) {
		this.setState({
			roleUpdateVisible: false,
		});
	}

	showReinviteModal = (record) => (e) => {
		this.setState({
			visible: true,
			isReinvite: true,
			userContact: record,
		});
	};

	handleBuyerReinviteSubmit(values) {
		const { updateUserContact, reinviteBuyerUser } = this.props;

		const updateContact = {
			...values,
			userId: values.email,
			roles: [values.roles],
		};
		if (!values.hasAccessToAllLocations) {
			updateContact['locationIds'] = values.locationIds;
		}

		updateUserContact(updateContact).then(() => {
			this.setState({ visible: false, isReinvite: false });
			reinviteBuyerUser(values.email).then(() => {
				this.fetchUsers();
				message.success(`User Reinvited`);
			});
		});
	}

	handleChangePasswordSubmit() {
		const { adminChangePassword } = this.props;
		const form = this.formRefs['changePasswordForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const updateContact = {
				userName: values.email,
				newPassword: values.newPassword,
			};

			adminChangePassword(updateContact).then(() => {
				const refreshRecords = new Promise((resolve) => resolve(this.fetchUsers()));
				refreshRecords.then(() => {
					this.setState({ changePasswordVisible: false });
					form.resetFields();
					message.success(`Password Changed`);
				});
			});
		});
	}

	handleChangePasswordCancel(e) {
		const form = this.formRefs['changePasswordForm'].props.form;
		form.resetFields();
		this.setState({
			changePasswordVisible: false,
		});
	}

	debouncedCallback = debounce(
		(searchText) => {
			this.setState({ searchText: searchText && searchText.trim() }, () => {
				this.fetchUsers();
			});
		},
		400,
		false
	);

	handleSearchDebounced = (e) => {
		const searchText = e.target.value;
		this.debouncedCallback(searchText);
	};

	switchDisplayMode = (e) => {
		const mode = nullSafeGet('target.value', e);
		this.setState({ displayMode: mode }, () => this.fetchUsers());
	};
	isDisplayModeActive = (mode) => this.state.displayMode === mode;

	render() {
		const { buyerUsers, disableBuyerUser, deleteBuyerUser, currentUser, downloadCSV } = this.props;
		const buyerUsersRecords = getObjectValues(buyerUsers.records).map((el) => ({
			...el,
			key: el.contact.email,
		}));

		const columns = [
			{
				title: 'Name',
				dataIndex: ['contact', 'nameGiven'],
				render: (text, record) => (
					<div>
						<ContactAvatar userType="buyer" contact={record.contact} />
						<span style={{ marginLeft: 16 }}>
							{record.contact.nameGiven} {record.contact.nameFamily}
						</span>
					</div>
				),
			},
			{
				title: 'Email',
				dataIndex: ['contact', 'email'],
			},
			{
				title: 'Roles',
				dataIndex: 'role',
				render: (text, record) => (
					<div>{record.role.map((r) => ROLES[r].displayName).join(', ')}</div>
				),
			},
			{
				title: 'Account Status',
				dataIndex: ['account'],
				render: (account, record) =>
					statusIndicatorFormatter(
						nullSafeGetOrElse('isInvited', account, false),
						nullSafeGetOrElse('isActive', account, false)
					),
			},
			{
				title: '',
				dataIndex: ['account', 'userName'],
				render: (text, record) => {
					const isInvited = nullSafeGetOrElse('account.isInvited', record, false);
					const isActive = nullSafeGetOrElse('account.isActive', record, false);
					const userName = nullSafeGet('account.userName', record);
					const isMe = compareStrings(userName, currentUser.email);

					if (isMe) {
						return null;
					} else if (isInvited) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={buyerUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showReinviteModal(record)}
								>
									Reinvite
								</Button>
								<Popconfirm
									title="Are you sure you want to delete this user?"
									onConfirm={() =>
										deleteBuyerUser(record.account.userName).then(() => this.fetchUsers())
									}
									okText="Delete"
									okButtonProps={{ danger: true }}
									cancelText="Cancel"
								>
									<Button danger loading={buyerUsers.loadingUsers.has(record.account.userName)}>
										Delete
									</Button>
								</Popconfirm>
							</Row>
						);
					} else if (isActive) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={buyerUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									danger
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={() =>
										disableBuyerUser(record.account.userName).then(() => this.fetchUsers())
									}
								>
									Disable
								</Button>
							</Row>
						);
					} else if (!isActive && !isInvited) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={buyerUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									loading={buyerUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showReinviteModal(record)}
								>
									Reinvite
								</Button>
								<Popconfirm
									title="Are you sure you want to delete this user?"
									onConfirm={() =>
										deleteBuyerUser(record.account.userName).then(() => this.fetchUsers())
									}
									okText="Delete"
									okButtonProps={{ danger: true }}
									cancelText="Cancel"
								>
									<Button danger loading={buyerUsers.loadingUsers.has(record.account.userName)}>
										Delete
									</Button>
								</Popconfirm>
							</Row>
						);
					}
				},
			},
		];

		return (
			<Content className="adminUsersPage" style={{ padding: '0 0.5em' }}>
				{this.state.visible ? (
					<BuyerUserInviteForm
						isReinvite={this.state.isReinvite}
						wrappedComponentRef={this.saveFormRef('userInviteForm')}
						visible={this.state.visible}
						formData={this.state.userContact}
						onCancel={this.handleBuyerUserInviteCancel}
						onSubmit={
							this.state.isReinvite
								? this.handleBuyerReinviteSubmit
								: this.handleBuyerUserInviteSubmit
						}
					/>
				) : null}
				{this.state.roleUpdateVisible ? (
					<BuyerAdminRoleUpdateForm
						wrappedComponentRef={this.saveFormRef('roleUpdateForm')}
						visible={this.state.roleUpdateVisible}
						formData={this.state.userContact}
						onCancel={this.handleBuyerRoleUpdateCancel}
						onSubmit={this.handleBuyerRoleUpdateSubmit}
					/>
				) : null}

				{this.state.changePasswordVisible ? (
					<PasswordUpdateForm
						wrappedComponentRef={this.saveFormRef('changePasswordForm')}
						visible={this.state.changePasswordVisible}
						formData={this.state.userContact}
						onCancel={this.handleChangePasswordCancel}
						onSubmit={this.handleChangePasswordSubmit}
					/>
				) : null}

				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<SubnavBar
							left={
								<div>
									<Input.Search
										placeholder="Filter by name or email"
										style={{ width: 240 }}
										onChange={this.handleSearchDebounced}
									/>
									<Radio.Group
										onChange={this.switchDisplayMode}
										value={this.state.displayMode}
										style={{ marginLeft: 16, marginTop: 4 }}
									>
										<Radio.Button value="active">Active</Radio.Button>
										<Radio.Button value="inactive">Inactive</Radio.Button>
										<Radio.Button value="invited">Invited</Radio.Button>
										<Radio.Button value="all">All</Radio.Button>
									</Radio.Group>
								</div>
							}
							right={
								<div>
									<Button
										size="large"
										icon={<DownloadOutlined />}
										className="inline-block-visible-md"
										onClick={() =>
											downloadCSV(this.state.displayMode, { search: this.state.searchText })
										}
									>
										<span className="inline-block-visible-xxl">Export CSV</span>
									</Button>
									<Button
										style={{ marginLeft: 16 }}
										type="primary"
										size="large"
										onClick={this.showInviteUserModal}
									>
										Invite New User
									</Button>
								</div>
							}
						/>
					</Col>
				</Row>
				<Row style={{ margin: '0.5em 0' }}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<Table
								columns={columns}
								dataSource={buyerUsersRecords}
								loading={buyerUsers.loading}
								pagination={this.initialPagination}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	buyerUsers: state.buyer_users,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchBuyerUsers: (filter) => dispatch(fetchFacilityUsers('buyer', filter)()),
	fetchInvitedBuyerUsers: (filter) => dispatch(fetchFacilityInvitedUsers('buyer', filter)()),
	fetchInactiveBuyerUsers: (filter) => dispatch(fetchFacilityInactiveUsers('buyer', filter)()),
	fetchBuyerActiveUsers: (filter) => dispatch(fetchFacilityActiveUsers('buyer', filter)()),
	disableBuyerUser: (userName) => dispatch(disableUser('buyer')(userName)),
	deleteBuyerUser: (userName) => dispatch(deleteUser('buyer')(userName)),
	inviteNewUser: (contact) => dispatch(buyerSignUpInvite(contact)),
	roleUpdateUser: (entity) => dispatch(buyerRoleUpdateUser(entity)),
	updateUserContact: (entity) => dispatch(buyerUpdateUserContact(entity)),
	reinviteBuyerUser: (userName) => dispatch(reinviteUser('buyer')(userName)),

	adminChangePassword: (entity) => dispatch(adminChangePassword(entity)),
	downloadCSV: (userType, params, filters = null) =>
		dispatch(downloadUsersCSV(ROLE_TYPES.BUYER)(userType, params, filters)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BuyerAdminUsersPage));
